// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, RedirectToPunchOutSubmit } from "@insite/client-framework/Store/Pages/Cart/Handlers/DoPunchOutCheckout";

type Parameter = { quoteId?: string } | undefined;
type HandlerType = Handler<Parameter>;

export const CustomRedirectToPunchOutSubmit: HandlerType = props => {
    const quoteIdQueryString = props.parameter?.quoteId ? `?quoteId=${props.parameter?.quoteId}` : "";
    window.location.href = `/api/v1/punchOut/porequisition${quoteIdQueryString}`;
};

replaceInChain(chain, RedirectToPunchOutSubmit, CustomRedirectToPunchOutSubmit);
